var _circle, _circle2, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSmileIllust(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10.0007,
    r: 9.16667,
    fill: "#FFC700"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10.0007,
    r: 9.16667,
    fill: "url(#paint0_linear_18242_130152)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5983 10.276H6.40514C6.26865 10.2693 6.13515 10.3192 6.03396 10.4147C5.93277 10.5103 5.87213 10.6438 5.86536 10.7858C5.86536 12.9391 7.72131 14.6914 10.0017 14.6914C12.2821 14.6914 14.1369 12.9391 14.1369 10.7858C14.1301 10.644 14.0696 10.5108 13.9687 10.4152C13.8678 10.3197 13.7346 10.2696 13.5983 10.276Z",
    fill: "#704207"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83338 8.97266C7.03121 8.97266 7.22458 8.89931 7.38906 8.76189C7.55353 8.62448 7.68171 8.42917 7.75737 8.20068C7.83302 7.97219 7.85275 7.72079 7.81407 7.47827C7.7754 7.23576 7.68004 7.01303 7.54007 6.83827C7.40011 6.66351 7.22182 6.54457 7.02777 6.4965C6.83371 6.44843 6.63261 6.47339 6.4499 6.56821C6.2672 6.66304 6.1111 6.82347 6.00136 7.02922C5.89161 7.23497 5.83315 7.47678 5.83337 7.72407C5.83337 7.88816 5.85925 8.05063 5.90952 8.20221C5.95979 8.35379 6.03347 8.49149 6.12634 8.60745C6.21922 8.72341 6.32946 8.81535 6.45078 8.87802C6.57209 8.94068 6.70211 8.97284 6.83338 8.97266Z",
    fill: "#4D2109",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1362 8.97266C13.3341 8.97266 13.5277 8.89931 13.6923 8.76189C13.8569 8.62448 13.9851 8.42917 14.0609 8.20068C14.1366 7.97219 14.1563 7.72079 14.1176 7.47827C14.0789 7.23576 13.9835 7.01303 13.8434 6.83827C13.7033 6.66351 13.5249 6.54457 13.3307 6.4965C13.1365 6.44843 12.9352 6.47339 12.7524 6.56821C12.5695 6.66304 12.4133 6.82347 12.3035 7.02922C12.1937 7.23497 12.1352 7.47678 12.1354 7.72407C12.1354 7.88816 12.1613 8.05063 12.2116 8.20221C12.2619 8.35379 12.3356 8.49149 12.4286 8.60745C12.5215 8.72341 12.6318 8.81535 12.7533 8.87802C12.8747 8.94068 13.0048 8.97284 13.1362 8.97266Z",
    fill: "#4D2109",
    fillOpacity: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18242_130152",
    x1: 4.94796,
    y1: 2.24023,
    x2: 15.1563,
    y2: 17.8652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDF6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC805"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSmileIllust);
export default __webpack_public_path__ + "static/media/ic_smile_illust.7105d42ae90eefa4ab7503669556b6f0.svg";
export { ForwardRef as ReactComponent };